<template>
  <v-col cols="12" sm="6" lg="3">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template slot="progress">
        <v-progress-linear color="indigo" indeterminate></v-progress-linear>
      </template>

      <v-card-text class="text-h6 font-weight-black card-indicador-titulo">
        Ocupação das salas
      </v-card-text>

      <v-card-text class="text-h4 font-weight-black card-indicador-valor d-flex align-center py-0">
        {{ taxa ? taxa : 0 }}%
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "TaxaOcupacao",
  props: {
    franquiaId: {
      type: Number,
    },
  },
  mounted() {
    this.getTaxa(this.franquiaId);
  },
  watch: {
    franquiaId(value) {
      this.getTaxa(value);
    },
  },
  data() {
    return {
      loading: true,
      taxa: 0,
    };
  },
  methods: {
    async getTaxa(franquiaId) {
      if (!franquiaId) return;
      this.loading = true;
      const data = await this.$services.turmasService.taxaOcupacao(franquiaId);
      this.taxa = data || 0;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.card-indicador-titulo {
  min-height: 96px;
}

.card-indicador-valor {
  height: 72px;
  white-space: nowrap;
}

div.chart-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
